import { Box, Typography } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PlaceIcon from "@mui/icons-material/Place";

import React from "react";

export default function FooterLower() {
  return (
    <div className="flex lg:items-center justify-between items-start">
      <Box className="text-primary flex items-center gap-4 ">
        {/* <Typography className="text-[12px] hover:text-orange-400 cursor-pointer">
          Terms & privacy
        </Typography> */}
        <div className="flex gap-[8px] items-center">
          <PlaceIcon className="text-[14px] lg:text-[16px]" />
          <Typography className="text-[12px] lg:text-[14px] hover:secondary cursor-pointer">
            First Floor, In5 Tech, Dubai Internet City, Dubai
          </Typography>
        </div>

        {/* <Typography className="text-[14px] hover:text-orange-400 cursor-pointer">
          &copy; Vaseelah 2025
        </Typography> */}
      </Box>
      <Box className="text-primary flex gap-6 ">
        {/* <XIcon className="text-[16px] hover:text-orange-400 cursor-pointer" />
        <InstagramIcon className="text-[16px] hover:text-orange-400 cursor-pointer" />
        <FacebookIcon className="text-[16px] hover:text-orange-400 cursor-pointer" /> */}
        <a
          target="_blank"
          className="text-primary"
          href="https://www.linkedin.com/company/priseen"
        >
          <LinkedInIcon className="text-[20px] hover:text-secondary transition-all duration-500 transform" />
        </a>
      </Box>
    </div>
  );
}
